import {AfterContentChecked, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Contract, CustomerDetails, VehicleDetails, Warranty} from '../../../models/warranties/warranty.model';
import {HttpService} from '../../../services/http.service';
import {ContractType} from '../../../models/warranties/contract-type.model';
import {SweetUtil} from '../../commons/sweet/sweet-util-service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {CustomerDetailsComponent} from '../customer-details/customer-details.component';
import {AcceptModalComponent} from '../accept-modal/accept-modal.component';
import {Dealer} from '../../../models/dealers/dealer.model';
import {DealerService} from '../../dealer/dealer.service';
import {ConfigurableDateService} from '../../../configurable-date/configurable-date.service';
import {DWPValidatorsService} from '../../../dwpvalidators.service';
import {ConfigurableDate} from '../../../configurable-date/configurable-date.model';
import {SpecialRequest} from '../../../special-request/special-request.model';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {DeclineComponent} from '../../../special-request/decline/decline.component';
import {DeclineSpecialRequestRequest} from '../../../special-request/decline-special-request-request.model';
import {PremiumCalculation} from '../../../special-request/premium-calculation/premium-calculation.model';
import {WarrantyService} from '../../../warranty/warranty.service';
import {FeatureToggleService} from '../../../toggle/feature-toggle.service';
import {FeatureToggle} from '../../../toggle/feature-toggle';
import {PreviousAgContract} from '../../../special-request/previous-ag-contract/previous-ag-contract.model';
import {ErrorMessageTranslatorService} from '../../../error-message-translator.service';
import {CapabilityService} from '../../../capability/capability.service';
import {CapabilityTo} from '../../../capability/capability-to';
import {LicensePlateService} from '../../../license-plate/license-plate.service';
import {LicensePlateTo} from '../../../license-plate/license-plate-to';
import {AuthService} from '../../../auth/auth.service';
import {Market} from '../../../models/dealers/market.enum';
import {I18nPipe} from '../../../services/i18n.pipe';
import {ConfirmationModalInfo} from './confirmation-modal-info';
import {CancelModalComponent} from '../cancel-modal/cancel-modal.component';
import {CreditNote} from '../../../models/warranties/credit-note.model';
import {DealerCorrectionReviewComponent} from '../../../dealer-correction-review/dealer-correction-review.component';
import {DealerCorrectionReviewService} from 'src/app/dealer-correction-review/dealer-correction-review.service';
import {DealerCorrectionReviewModel} from 'src/app/models/warranties/dealer-coorection-review.model';

@Component({
  selector: 'app-warranty',
  templateUrl: './warranty.component.html',
  styleUrls: ['./warranty.component.scss']
})
export class WarrantyComponent implements OnInit, OnDestroy, AfterContentChecked {

  @ViewChild('customerOwner') customerOwner: CustomerDetailsComponent;
  @ViewChild('customerKeeper') customerKeeper: CustomerDetailsComponent;
  @ViewChild('customerUser') customerUser: CustomerDetailsComponent;
  @ViewChild('modalComponent') modalComponent: AcceptModalComponent;
  @ViewChild('cancelComponent') cancelComponent: CancelModalComponent;
  @ViewChild('keywordVin') keywordVin: ElementRef;
  @ViewChild('dealerCorrectionReview') dealerCorrectionReview: DealerCorrectionReviewComponent;
  messages: DealerCorrectionReviewModel[];
  overruleOnExtendedWarrantyToggleActive = false;
  editable = true;
  approvalInProgress = false;
  sub: any;
  step: any = 0;
  vin = '';
  licensePlate = '';
  vinError = '';
  licenceError = '';
  dateOfRegError = '';
  orderDateError = '';
  contractTypeError = '';
  contractDurationError = '';
  deliveryDateError = '';
  deliveryLocationError = '';
  deliveryMileageError = '';
  sellingDealerError = '';
  deliveringAgentError = '';
  licensePlateError = '';
  licensePlateSearchResults: LicensePlateTo;

  customerOptions: { customerId: string, owner: CustomerDetails, keeper: CustomerDetails, user: CustomerDetails }[];
  ownersList: { customerId: string, owner: CustomerDetails }[] = [];
  warranty: Warranty = new Warranty();
  sellingDealer: Dealer = null;
  contractTypes: ContractType[] = [];
  deliveringAgentNumber = '';
  selectedContractType: ContractType = null;
  dealerOptions: Dealer[] = [];
  warrantyProgress = '';
  ownerIsKeeper: boolean;
  ownerIsUser: boolean;
  isAdmin = false;
  premiumCalculation: PremiumCalculation;

  question1: string;
  question2: string;
  submission: ConfigurableDate;
  saving: ConfigurableDate;
  displaySpecialRequest = false;
  firstRegistrationDateMin: string;
  mileageAndDatesValidationToggle: boolean;
  firstRegistrationDateFromSourceToggle: boolean;
  nwsVinValidation: boolean;
  licensePlateToVinToggle: boolean;
  minimumNumberOfDaysNl: boolean;
  previousAgContract: PreviousAgContract;
  isDealerLinkToProductEnabled = false;
  capabilities: CapabilityTo;
  showPrintButtons = false;
  showSalesPrice = false;
  showReadOnlyDate = false;
  hasCreditNote = false;
  creditNote: CreditNote;
  beluxDealer: string;

  constructor(private service: WarrantyService, public http: HttpService, private router: Router, private route: ActivatedRoute,
              private sweetUtil: SweetUtil, private dealerService: DealerService,
              private errorMessageTranslator: ErrorMessageTranslatorService, private validators: DWPValidatorsService,
              private configurableDateService: ConfigurableDateService, private modal: NgbModal,
              private featureToggleService: FeatureToggleService, private capabilityService: CapabilityService,
              private licensePlateService: LicensePlateService, private authService: AuthService, private i18nPipe: I18nPipe,
              // tslint:disable-next-line:max-line-length
              private cdref: ChangeDetectorRef, private dealerCorrectionReviewService: DealerCorrectionReviewService) {
  }

  ngOnInit(): void {
    this.showPrintButtons = !this.authService.isSelectedLanguageEnglish() && (this.authService.market() === Market.BE);
    this.showSalesPrice = this.authService.market() === Market.NL;
    this.showReadOnlyDate = this.authService.market() === Market.NL;
    this.checkIsDealerLinkToProductEnabled();
    this.isAdmin = this.authService.isAdmin();
    this.fetchDealers();
    this.configurableDateService.configurableDates().subscribe((configurableDates) => {
      this.saving = configurableDates.find((date) => date.type === 'Saving');
      this.submission = configurableDates.find((date) => date.type === 'Submission');
    });
    this.sub = this.route.params.subscribe((parameters: Params) => {
      if (parameters.id && !isNaN(parameters.id)) {
        this.http.fetchWarranty(parameters.id).subscribe((res) => {
          this.warranty = Object.assign(res);
          this.selectedContractType = this.contractTypes.find(c => c.contractType === this.warranty.contract.contractType);
          this.step = this.warranty.warrantyStatus === 'In Review' ? 3 : this.warranty.maxStep;
          this.fetchAcceptanceQuestions();
          this.setWarrantyString();
          this.fetchCreditNotes();
          this.editable = this.warrantyEditable();
          if (this.warranty.specialRequestRequested) {
            this.fetchWarrantyChats();
          }
        });
      } else if (parameters.id && isNaN(parameters.id)) {
        this.warranty = new Warranty();
        this.warranty.isExtended = true;
        this.editable = this.warrantyEditable();
      } else {
        this.warranty = new Warranty();
        this.editable = this.warrantyEditable();
      }
    });
    const today = new Date();
    today.setFullYear(today.getFullYear() - 10);
    this.firstRegistrationDateMin = today.toJSON().slice(0, 10);
    this.featureToggleService.isFeatureToggleActive(FeatureToggle.WARRANTY_MILEAGE_DATES_VALIDATIONS).subscribe((toggleStatus) => {
      this.mileageAndDatesValidationToggle = toggleStatus;
    });

    this.featureToggleService.isFeatureToggleActive(FeatureToggle.OVERRULE_ON_EXTENDED_WARRANTY).subscribe((active) => {
      this.overruleOnExtendedWarrantyToggleActive = active;
    });
    this.featureToggleService.isFeatureToggleActive(FeatureToggle.FIRST_REGISTRATION_DATE_FROM_SOURCE).subscribe((active) => {
      this.firstRegistrationDateFromSourceToggle = active;
    });

    this.featureToggleService.isFeatureToggleActive(FeatureToggle.NWS_ERROR_VALIDATION).subscribe((toggleStatus) => {
      this.nwsVinValidation = toggleStatus;
    });

    this.featureToggleService.isFeatureToggleActive(FeatureToggle.NWS_ERROR_VALIDATION).subscribe((toggleStatus) => {
      this.nwsVinValidation = toggleStatus;
    });
    this.featureToggleService.isFeatureToggleActive(FeatureToggle.LICENSE_PLATE_TO_VIN).subscribe((toggleStatus) => {
      this.licensePlateToVinToggle = toggleStatus;
    });
    this.featureToggleService.isFeatureToggleActive(FeatureToggle.MINIMUM_NUMBER_OF_DAYS_NL).subscribe((toggleStatus) => {
      const nl: boolean = this.authService.market() === Market.NL;
      this.minimumNumberOfDaysNl = toggleStatus && nl;
    });
    this.capabilityService.getCapabilities().subscribe((capabilities) => {
      this.capabilities = capabilities;
    });
    this.beluxDealer = 'BMW Group Belux';
    this.deliveringAgentNumber = '05668';
  }

  fetchWarrantyChats() {
    // tslint:disable-next-line:max-line-length
    this.dealerCorrectionReviewService.getDealerCorrectionReviews(this.warranty.specialRequest.id).subscribe((dealerCorrectionReviewService) => {
      this.dealerCorrectionReviewService.dealerCorrectionReviews = dealerCorrectionReviewService;
      this.messages = this.dealerCorrectionReviewService.dealerCorrectionReviews;
    });
  }


  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  fetchCreditNotes() {
    this.http.getCreditNote(this.warranty.id).subscribe((creditNote) => {
      this.creditNote = creditNote;
      this.hasCreditNote = creditNote !== null;
    });
  }

  displayPreviousAgContract(): boolean {
    return this.overruleOnExtendedWarrantyToggleActive && this.approvalInProgress && this.isAdmin &&
      !this.warranty.euroPlus07CGOr07CHFound && !this.warranty.contract.used;
  }

  onPreviousAgContract(previousAgContract: PreviousAgContract): void {
    this.previousAgContract = previousAgContract;
    if (previousAgContract) {
      this.warranty.euroPlusContractTypeEnteredManually = previousAgContract.contractType;
      this.warranty.euroPlusContractEndDateEnteredManually = previousAgContract.endDate;
    } else {
      this.warranty.euroPlusContractTypeEnteredManually = null;
      this.warranty.euroPlusContractEndDateEnteredManually = null;
    }

    if (!this.approvalIneligible()) {
      this.saveWarranty();
    }

  }

  submissionEnabled(): boolean {
    return this.editable && this.warranty.contract.oilChangesTimely && this.warranty.contract.passed360 ||
      this.isAdmin && this.approvalInProgress;
  }

  displayOpenContract(): boolean {
    return this.warranty.warrantyStatus === 'In Review' && !this.approvalInProgress && this.warranty.id > 0;
  }

  approve(): void {
    this.http.saveWarranty(this.warranty).subscribe((res) => {
      this.warranty = Object.assign(res);
      this.stepToFour();
    }, (error) => {
      this.sweetUtil.showError(`The following error occurred ${JSON.stringify(error)}`);
    });
  }

  openContract(): void {
    this.approvalInProgress = true;
    this.stepToTwo();
  }

  displayPrintButtons(): boolean {
    return (this.warranty.warrantyStatus && this.warranty.warrantyStatus === 'Active' ||
        this.warranty.warrantyStatus && this.warranty.warrantyStatus === 'Accepted') &&
      (
        this.warranty.contract.contractType === '' || this.warranty.contract.contractType === 'MINI NEXT' ||
        this.warranty.contract.contractType === 'Motorrad Premium Selection' ||
        this.warranty.contract.contractType === 'BMW Premium Selection') && this.showPrintButtons;
  }

  onPremiumCalculation(premiumCalculation: PremiumCalculation): void {
    this.premiumCalculation = premiumCalculation;
    this.warranty.contract.penaltyOrDiscount = null;
    this.warranty.contract.amountToBeCharged = null;
    if (premiumCalculation) {
      if (premiumCalculation.penaltyOrDiscount) {
        this.warranty.contract.penaltyOrDiscount = premiumCalculation.penaltyOrDiscount;
      }
      if (premiumCalculation.amountToBeCharged || premiumCalculation.amountToBeCharged === 0) {
        this.warranty.contract.amountToBeCharged = premiumCalculation.amountToBeCharged;
      }

    } else {
      this.warranty.contract.penaltyOrDiscount = null;
      this.warranty.contract.amountToBeCharged = null;
    }

  }

  approvalIneligible(): boolean {

    return this.premiumCalculation?.penaltyOrDiscount === null || this.premiumCalculation?.amountToBeCharged === null ||
      this.premiumCalculation?.penaltyOrDiscount === undefined || this.premiumCalculation?.amountToBeCharged === undefined ||
      isNaN(this.premiumCalculation?.penaltyOrDiscount) || isNaN(this.premiumCalculation?.amountToBeCharged) ||
      (this.displayPreviousAgContract() && !this.previousAgContract);
  }

  displayPremiumCalculation(): boolean {
    return this.approvalInProgress && this.isAdmin && this.warranty.warrantyStatus === 'In Review';
  }

  specialRequestActionable(): boolean {
    return this.isAdmin && this.warranty.warrantyStatus === 'In Review' && this.warranty.specialRequestRequested &&
      this.warranty.specialRequest !== null;
  }

  specialRequestRequired(value: boolean): void {

    this.service.specialRequestExistsForVin(this.warranty.vehicle.vin).subscribe((exists) => {
      if (exists) {
        this.displaySpecialRequest = false;
        this.sweetUtil.showError('There is already another special request being considered for this vin');
      } else {
        this.displaySpecialRequest = value;
        this.warranty.specialRequestRequested = value;
      }
    });

  }

  adminCreatingNewWarranty(): boolean {
    return this.isAdmin && !(this.warranty.id > 0);
  }

  declineSpecialRequest(): void {
    const specialRequestItem: NgbModalRef = this.modal.open(DeclineComponent);
    if (specialRequestItem && specialRequestItem.componentInstance) {
      const declineSpecialRequestRequest: DeclineSpecialRequestRequest = {
        warrantyId: this.warranty.id,
        specialRequestId: this.warranty.specialRequest.id,
        declineReason: null
      };
      specialRequestItem.componentInstance.declineSpecialRequestRequest = declineSpecialRequestRequest;
      specialRequestItem.result.then(() => {
        this.router.navigateByUrl('dashboard').then(() => {
        });
      });
    }
  }

  warrantyEditable(): boolean {
    const warranty: Warranty = new Warranty();
    warranty.warrantyStatus = this.warranty.warrantyStatus;
    warranty.specialRequestRequested = this.warranty.specialRequestRequested;
    return warranty.editable(this.isAdmin);
  }

  setWarrantyString() {
    if (this.warranty?.vehicle?.vin) {
      this.warrantyProgress = (this.warranty.vehicle.model + ' (' + this.warranty.vehicle.vin + ')');
      if (this.warranty.owner.firstName && this.warranty.owner.lastName) {
        this.warrantyProgress += ' > ' + this.warranty.owner.firstName + ' ' + this.warranty.owner.lastName;
        if (this.warranty.contract.contractType) {
          this.warrantyProgress += ' > ' + this.warranty.contract.contractType + ' (' + this.warranty.contract.contractCode + ')';
          if (this.warranty.warrantyNumber) {
            this.warrantyProgress += ' > ' + this.warranty.warrantyNumber;
          }
        }
      }
    }
  }

  resetDataAndForm(extended: boolean) {
    this.step = 0;
    this.warranty = new Warranty();
    this.warranty.isExtended = extended;
    this.contractTypes = [];
    this.ownersList = [];
    this.customerOptions = [];
  }

  searchVin() {
    this.vinError = '';
    this.licensePlateError = '';
    this.vin = this.vin.trim().toUpperCase();
    if (this.vin.length === 17) {
      this.resetDataAndForm(this.warranty.isExtended);
      this.http.fetchVinAndCustomerData(this.vin, this.warranty.isExtended).subscribe((res: any) => {
        this.warranty.vehicle = Object.assign(new VehicleDetails(), res.vehicle);
        if (!this.warranty.vehicle.licencePlate && this.licensePlate) {
          this.warranty.vehicle.licencePlate = this.licensePlate;
        }
        if (res.owner != null) {
          this.warranty.owner = Object.assign(new CustomerDetails(), res.owner);
        }
        this.warranty.keeper = Object.assign(new CustomerDetails(), res.keeper);
        this.warranty.user = Object.assign(new CustomerDetails(), res.user);
        this.customerOptions = Object.assign([], res.customerOptions);
        this.warranty.contract = Object.assign(new Contract(), res.contract);
        this.customerOptions.forEach(c => {
          this.ownersList.push({customerId: c.customerId, owner: c.owner});
        });
        if (this.licensePlateSearchResults && this.licensePlateSearchResults.firstRegistrationDate) {
          this.updateLicensePlateFromSource();
        } else if (this.authService.market() === Market.NL && this.licensePlateToVinToggle) {
          this.licensePlateService.getLicensePlateByVin(this.warranty.vehicle.vin).subscribe((response: LicensePlateTo) => {
            this.licensePlateError = '';
            this.licensePlateSearchResults = response;
            this.updateLicensePlateFromSource();
          });
        }
      }, error => {
        console.error(`Status ${error.status}`);
        if (error.status === 422) {
          this.vinError = 'blacklisted-vin-error';
        } else if (error.status === 503) {
          this.vinError = 'vis-not-available';
        } else if (error.status === 404) {
          this.vinError = this.i18nPipe.transform('', 'cannot-find-vin-in-vis-database-please-check-if-the-vin-is-correct');
        } else if (error.status === 423) {
          this.vinError = 'VIN is invalid and cannot be processed (expected 17 character VIN)';
        } else if (error.status === 424) {
          this.vinError = 'nws-validation-error';
        } else if (error.status === 426) {
          this.vinError = 'Previous contract within 2 month minimum end date. Cannot extend Warranty for this VIN.';
        } else if (error.status === 428 || error.status === 412) {
          this.vinError = 'Previous warranties found. Cannot extend Warranty for this VIN.';
        } else if (error.status === 500) {
          this.vinError = this.i18nPipe.transform('', 'cancellation-date-validation');
        }else {
          this.vinError = typeof error.error === 'string' ? error.error : 'Cannot find VIN in VIS Database - please try again or try a different VIN';
        }
      });
    } else {
      this.vinError = 'VIN must be 17 characters';
    }
  }

  private updateLicensePlateFromSource() {
    this.warranty.vehicle.dateOfRegistration = this.licensePlateSearchResults.firstRegistrationDate;
    this.warranty.vehicle.isFirstRegistrationDateFromSource = true;
    this.warranty.vehicle.licencePlate = this.licensePlateSearchResults.licensePlate;
    this.warranty.vehicle.isLicencePlateDateFromSource = true;
    this.licensePlateSearchResults = undefined;
  }

  selectCustomer(customerId: string) {
    const customerRow = this.customerOptions.find((customerOption) => customerOption.customerId === customerId);
    this.warranty.owner = Object.assign(new CustomerDetails(), customerRow.owner);
    this.warranty.user = Object.assign(new CustomerDetails(), customerRow.user);
    this.warranty.keeper = Object.assign(new CustomerDetails(), customerRow.keeper);
    this.continue();
  }

  captureNewCustomer() {
    this.continue();
  }

  stepToOne() {
    this.licenceError = '';
    this.dateOfRegError = '';
    if (this.dateTodayOrInFuture(this.warranty.vehicle.dateOfRegistration)) {
      this.dateOfRegError = 'Date cannot be in the future';
      return;
    }
    if (!this.warranty.owner) {
      this.warranty.owner = new CustomerDetails();
    }
    if (!this.warranty.user) {
      this.warranty.user = new CustomerDetails();
    }
    if (!this.warranty.keeper) {
      this.warranty.keeper = new CustomerDetails();
    }

    this.step = 1;
    if (this.warranty.maxStep < this.step) {
      this.warranty.maxStep = this.step;
    }
  }

  fetchDealers(): void {
    this.isAdmin ? this.http.fetchDealers().subscribe((dealers: Array<Dealer>) => {
      this.dealerOptions = dealers;
      this.selectDealer(this.dealerOptions);
    }) : this.http.fetchDealerOptions().subscribe((res) => {
      this.dealerOptions = Object.assign([], res);
      this.selectDealer(this.dealerOptions);
    });
  }
  fetchDeliveringAgent(): void {
    this.isAdmin ? this.http.fetchDeliveringAgent().subscribe((dealers: Array<Dealer>) => {
      this.dealerOptions = dealers;
      this.selectDealer(this.dealerOptions);
    }) : this.http.fetchDealerOptions().subscribe((res) => {
      this.dealerOptions = Object.assign([], res);
      this.selectDealer(this.dealerOptions);
    });
  }
  fetchDealersByContractType(contractType: string) {
    this.http.fetchDealersByContractType(contractType).subscribe(dealers => {
      this.dealerOptions = dealers;
    });
  }

  private checkIsDealerLinkToProductEnabled() {
    this.featureToggleService
      .isFeatureToggleActive(FeatureToggle.DEALER_LINK_TO_PRODUCT)
      .subscribe(result => this.isDealerLinkToProductEnabled = result);
  }

  selectDealer(dealers: Dealer[]) {
    const selectedDealers = dealers.filter((dealer) => this.warranty?.contract?.deliveryLocation === dealer.dealerName);
    if (selectedDealers && selectedDealers.length > 0) {
      this.sellingDealer = selectedDealers[0];
    } else {
      if (this.warranty && this.warranty.contract && this.warranty.contract.deliveryLocation) {
        this.dealerService.dealersByName(this.warranty.contract.deliveryLocation).subscribe((sellingDealers: Array<Dealer>) => {
          if (sellingDealers && sellingDealers.length > 0) {
            const selectedDealer = sellingDealers[0];
            this.dealerOptions.push(selectedDealer);
            this.sellingDealer = selectedDealer;
          }
        });
      }
    }
  }

  stepToTwo() {
    this.step = 2;
    this.getAvailableContractTypes();
    this.fetchDealers();
  }

  stepToThreeFree() {
    if (this.warranty.id) {
      this.fetchAcceptanceQuestions();
      this.step = 3;
      this.fetchDeliveringAgent();
    }
  }

  fetchAcceptanceQuestions() {
    this.http.fetchAcceptanceCriteria(this.warranty.contract.contractCode).subscribe((res: any) => {
      this.question1 = res.oilChangeQuestion;
      this.question2 = res.passed360Question;
    });
  }

  stepToThree() {
    if (this.validWarrantDetails()) {
      if (this.warranty.contract.contractCode === '12BSUP' || this.warranty.contract.contractCode === '12MSUP') {
        this.warranty.contract.passed360 = true;
      }
      this.fetchAcceptanceQuestions();
      this.continue();
      this.saveWarranty();
    }
  }

  specialRequestValid(): boolean {
    return (this.warranty.specialRequestRequested && this.warranty && this.warranty.specialRequest &&
      this.warranty.specialRequest.justification?.trim()?.length > 0 ||
      !this.warranty.specialRequestRequested);
  }

  proceedToStep4Eligible(): boolean {
    return this.editable && this.warranty.contract && (this.warranty.contract.oilChangesTimely && this.warranty.contract.passed360 ||
        this.warranty.specialRequestRequested === true) &&
      this.specialRequestValid();
  }

  isCancelAllowed() {
    return this.isAdmin && this.warranty.warrantyStatus === 'Active';
  }


  isAbortAllowed() {
    return (this.warranty.warrantyStatus === 'In Progress' || this.warranty.warrantyStatus === 'Accepted');
  }

  isYUCAllowed(): boolean {
    return (!this.isAdmin && (this.warranty.warrantyStatus && this.warranty.warrantyStatus === 'In Progress' ||
      this.warranty.warrantyStatus && this.warranty.warrantyStatus === 'Accepted' || this.warranty.warrantyStatus
      && this.warranty.warrantyStatus === 'Active') && this.warranty.contract.contractType === 'MINI NEXT YUC');
  }

  isSpecialRequestAllowed(): boolean {
    return (!this.isAdmin && (this.warranty.warrantyStatus && this.warranty.warrantyStatus === 'Accepted' || this.warranty.warrantyStatus
      && this.warranty.warrantyStatus === 'Active'));
  }

  stepToFour() {
    this.step = 4;
    this.warranty.maxStep = 4;
    this.saveWarranty();
  }

  distinctContractTypes(): Array<ContractType> {
    const distinct: Array<ContractType> = [];

    this.contractTypes.forEach((subject) => {
      if (distinct.find((contractType) => contractType.contractType === subject.contractType)) {
      } else {
        distinct.push(subject);
      }
    });
    if (!this.isAdmin) {
      const distinctUser = distinct.filter(item => {
        return !item.contractType.includes('YUC');
      });
      return distinctUser;
    }
    return distinct;
  }

  getAvailableContractTypes() {
    const createdDate: string = this.warranty.dateCreated ? this.warranty.dateCreated : null;
    this.http.fetchContractTypesWithStartDate(this.warranty.vehicle.brand, this.warranty.vehicle.vin,
      this.warranty.contract.orderDate, createdDate, this.warranty.isExtended).subscribe((res) => {
      this.contractTypes = Object.assign([], res);
      if (this.warranty.contract.contractType) {
        this.selectedContractType = this.contractTypes.find(c => c.contractType === this.warranty.contract.contractType);
      }
    });
  }

  selectContractType() {
    this.selectedContractType = this.contractTypes.find(c => c.contractType === this.warranty.contract.contractType);
    this.warranty.contract.contractCode = null;
    if (this.isDealerLinkToProductEnabled && this.selectedContractType.contractType.toString() === 'MINI NEXT YUC' ){
      (this.selectedContractType) ? this.fetchDealers() : this.fetchDealers();
    }else {
      this.sellingDealer = null;
      this.warranty.dealerNumber = null;
      this.warranty.contract.deliveryLocation = null;
      (this.selectedContractType) ? this.fetchDealersByContractType(this.selectedContractType.contractType) : this.fetchDealers();
    }
  }

  completeCustomerDetailsAndContinue() {
    const ownerValid = this.customerOwner.isValid();
    const userValid = !this.warranty.isExtended ? this.customerUser.isValid() : true;
    const keeperValid = !this.warranty.isExtended ? this.customerKeeper.isValid() : true;
    if (ownerValid && userValid && keeperValid) {
      this.updateCustomerDetails();
      this.getAvailableContractTypes();
      this.continue();
    }
  }

  mergeOwnerAndUser() {
    if (this.ownerIsUser) {
      this.warranty.user = this.customerOwner.getCustomerDetails();
    } else {
      this.warranty.user = new CustomerDetails();
    }
  }

  mergeOwnerAndKeeper() {
    if (this.ownerIsKeeper) {
      this.warranty.keeper = this.customerOwner.getCustomerDetails();
    } else {
      this.warranty.keeper = new CustomerDetails();
    }
  }

  updateCustomerDetails() {
    this.warranty.owner = this.customerOwner.getCustomerDetails();
    if (!this.warranty.isExtended) {
      this.warranty.user = this.customerUser.getCustomerDetails();
      this.warranty.keeper = this.customerKeeper.getCustomerDetails();
    }
  }

  continue() {
    this.setWarrantyString();
    this.step++;
    if (this.warranty.maxStep < this.step) {
      this.warranty.maxStep = this.step;
    }
  }

  saveWarranty() {
    if (!this.specialRequestValid()) {
      this.sweetUtil.showError('invalid-special-request-validation-error');
      return;
    }
    this.http.saveWarranty(this.warranty).subscribe((res) => {
      this.warranty = Object.assign(res);
    }, error => {
      this.errorMessageTranslator.translateAndShowErrorMessageRequiringSpecialRequest(error, false);
    });
  }

  openModal() {
    if (!this.specialRequestValid()) {
      this.sweetUtil.showError('invalid-special-request-validation-error').then();
      return;
    }
    if (this.warranty.isExtended) {
      SweetUtil.getConfirm('Submit Warranty?', 'Are you sure you want to submit this extended warranty?').then((res) => {
        if (res.value) {
          this.http.saveWarranty(this.warranty).subscribe(() => {
            this.http.submitWarranty(this.warranty.id).subscribe(() => {
              SweetUtil.showSuccess('Warranty Successfully Submitted').then();
              this.router.navigate(['/dashboard']).then();
            }, error => {
              this.errorMessageTranslator.translateAndShowErrorMessageRequiringSpecialRequest(error);
            });
          }, (error) => {
            this.errorMessageTranslator.translateAndShowErrorMessageRequiringSpecialRequest(error, false);
          });
        }
      });
    } else {
      const deliveryDate: Date = new Date(this.warranty.contract.deliveryDate);
      const orderDate: Date = new Date(this.warranty.contract.orderDate);

      if (this.submission && (this.validators.dateWithinDaysInThePast(orderDate, this.submission.orderDateMaxNumberOfDaysInThePast) ||
          this.validators.dateWithinDaysInTheFuture(orderDate, this.submission.orderDateMaxNumberOfDaysInTheFuture)) &&
        this.submission && (
          this.validators.dateWithinDaysInThePast(deliveryDate, this.submission.deliveryDateMaxNumberOfDaysInThePast) ||
          this.validators.dateWithinDaysInTheFuture(deliveryDate, this.submission.deliveryDateMaxNumberOfDaysInTheFuture) ||
          (this.minimumNumberOfDaysNl && this.authService.market() === Market.NL && !this.validators.dateWithinDaysInTheFuture(deliveryDate,
            this.submission.deliveryDateMinNumberOfDaysInTheFuture)))
        || this.submission && this.isAdmin && this.warranty.warrantyStatus === 'In Review'
      ) {
        this.modalComponent.openModal();
      } else {
        this.sweetUtil.showError('Submission Failed as either the order date or delivery date or both fall outside the allowed ranges.'
          .toUpperCase()).then(() => {
        });
      }

    }
  }

  saveAndClose() {
    this.saveWarranty();
    this.router.navigate(['/']).then();
  }

  onSpecialRequest(specialRequest: SpecialRequest): void {
    this.warranty.specialRequest = specialRequest;
  }

  onCancel() {
    this.cancelComponent.openModal(this.warranty);
  }

  abortWarranty() {
    const wording = this.getAbortOrCancelWording(this.warranty.warrantyStatus);
    if (this.canAbort()) {
      SweetUtil.getConfirm(wording.popUpTitle, wording.popUpText, wording.confirmButtonText, wording.cancelButtonText)
        .then((res) => {
          if (res.value) {
            this.http.abortWarranty(this.warranty.id).subscribe(() => {
              SweetUtil.showSuccess(wording.successText).then(() => {
                this.router.navigate(['/']).then();
              });
            });
          }
        });
    } else {
      SweetUtil.showInfo(wording.failureText);
    }
  }

  getAbortOrCancelWording(status: string): ConfirmationModalInfo {
    const popUpWording = status === 'Active' ?
      {
        popUpTitle: 'cancel-warranty',
        popUpText: 'cancel-confirmation',
        failureText: 'can-not-cancel-warranty',
        successText: 'warranty-cancelled',
        confirmButtonText: 'yes',
        cancelButtonText: 'cancel'
      } :
      {
        popUpTitle: 'abort-warranty',
        popUpText: 'abort-confirmation',
        failureText: 'can-not-abort-warranty',
        successText: 'warranty-aborted',
        confirmButtonText: 'yes',
        cancelButtonText: 'cancel'
      };

    Object.keys(popUpWording).forEach(x => popUpWording[x] = this.i18nPipe.transform('', popUpWording[x]));
    return popUpWording;
  }

  printCertificate(warrantyNumber: string) {
    this.http.downloadCertificate(warrantyNumber, warrantyNumber + '_Certificate.pdf', this.authService.getSelectedLanguage());
  }

  validWarrantDetails(): boolean {
    this.orderDateError = '';
    this.contractTypeError = '';
    this.contractDurationError = '';
    this.deliveryDateError = '';
    this.deliveryLocationError = '';
    this.deliveryMileageError = '';

    if (!this.warranty.contract.orderDate) {
      this.orderDateError = 'Required Date.';
      return false;
    }

    const orderDate: Date = new Date(this.warranty.contract.orderDate);
    if (this.saving && (this.validators.dateWithinDaysInThePast(orderDate, this.saving.orderDateMaxNumberOfDaysInThePast) ||
      this.validators.dateWithinDaysInTheFuture(orderDate, this.saving.orderDateMaxNumberOfDaysInTheFuture))) {
      this.orderDateError = '';
    } else {
      this.orderDateError = `Date must be within ${this.saving.orderDateMaxNumberOfDaysInThePast} days back of today and ${this.saving.orderDateMaxNumberOfDaysInTheFuture} forward of today.`.toUpperCase();
      if (this.isAdmin && this.saving && this.warranty.warrantyStatus === 'In Review') {
      } else {
        return false;
      }
    }

    if (!this.warranty.contract.contractType || this.warranty.contract.contractType === 'null') {
      this.contractTypeError = 'Please select a contract type.';
      return false;
    }

    if (!this.warranty.contract.contractCode || this.warranty.contract.contractCode === 'null') {
      this.contractDurationError = 'Please select a contract duration.';
      return false;
    }

    if (!this.sellingDealer || this.sellingDealer.dealerName === '' || this.sellingDealer === null) {
      this.sellingDealerError = 'selling-dealer-validation';
      return false;
    }
    if (!this.sellingDealer) {
      this.deliveringAgentError = 'delivering-agent-validation';
      return false;
    }
    if (!this.warranty.isExtended) {
      if (!this.warranty.contract.deliveryDate) {
        this.deliveryDateError = 'Required Date.';
        return false;
      }

      const deliveryDate = new Date(this.warranty.contract.deliveryDate);

      if (this.saving && (this.validators.dateWithinDaysInThePast(deliveryDate, this.saving.deliveryDateMaxNumberOfDaysInThePast) ||
        this.validators.dateWithinDaysInTheFuture(deliveryDate, this.saving.deliveryDateMaxNumberOfDaysInTheFuture))) {
        this.deliveryDateError = '';
      } else {
        this.deliveryDateError = `Delivery Date must be within the last ${this.saving.deliveryDateMaxNumberOfDaysInThePast} or next
        ${this.saving.deliveryDateMaxNumberOfDaysInTheFuture} days.`.toUpperCase();
        if (this.isAdmin && this.saving && this.warranty.warrantyStatus === 'In Review') {
        } else {
          return false;
        }
      }

      if (this.minimumNumberOfDaysNl && this.saving && (this.validators.dateWithinDaysInTheFuture(deliveryDate, this.saving
        .deliveryDateMinNumberOfDaysInTheFuture))) {
        if (this.isAdmin && this.saving && this.warranty.warrantyStatus === 'In Review') {
        } else {
          this.deliveryDateError = `minimum-number-of-days-nl`;
          return false;
        }
      } else {
        this.deliveryDateError = '';
      }

      if (!this.warranty.contract.deliveryMileage || isNaN(this.warranty.contract.deliveryMileage)) {
        this.deliveryMileageError = 'delivery-mileage-error-message';
        return false;
      }

      if (this.mileageAndDatesValidationToggle) {
        if (this.warranty.vehicle.mileage && this.warranty.vehicle.mileageDate) {
          if (this.isDeliveryMileageIncorrect()) {
            this.deliveryMileageError = 'mileage-delivery-date-validation';
            return false;
          }
        }

        if (this.validators.isDateBefore(this.warranty.contract.deliveryDate, this.warranty.contract.orderDate)) {
          this.deliveryDateError = 'delivery-date-order-date-validation';
          return false;
        }

        // if (this.validators.isDateBefore(this.warranty.vehicle.dateOfRegistration, this.firstRegistrationDateMin)) {
        //   this.dateOfRegError = `Date of registration must be within 10 years`;
        //   return false;
        // }
        // if (this.validators.compareDates(this.warranty.contract.deliveryDate, this.warranty.vehicle.mileageDate) === 0) {
        //   if ((Number(this.warranty.contract.deliveryMileage) + 201) > Number(this.warranty.vehicle.mileage)) {
        //     this.deliveryMileageError = 'mileage-not-plausible-at-day-of-delivery';
        //     return false;
        //   }
        // }
        // if (this.validators.isDateEqualOrBefore(this.warranty.contract.deliveryDate, this.warranty.vehicle.mileageDate)) {
        //   if ((Number(this.warranty.contract.deliveryMileage) - 201) < Number(this.warranty.vehicle.mileage)) {
        //     this.deliveryMileageError = 'mileage-not-plausible-at-day-of-delivery';
        //     return false;
        //   }
        // }
      }
    }
    return true;
  }

  private isDeliveryMileageIncorrect() {
    return (this.validators.isDateBefore(this.warranty.contract.deliveryDate, this.warranty.vehicle.mileageDate)
        && Number(this.warranty.contract.deliveryMileage) > Number(this.warranty.vehicle.mileage)) ||
      (this.validators.isDateEqualOrAfter(this.warranty.contract.deliveryDate, this.warranty.vehicle.mileageDate)
        && Number(this.warranty.contract.deliveryMileage) < Number(this.warranty.vehicle.mileage));
  }

  dateTodayOrInFuture(date: string) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    const today = this.todayStartOfDay();
    return d >= today;
  }

  public todayStartOfDay() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  getDateDaysFromToday(dateOffSet: number) {
    return new Date().setDate(new Date().getDate() + dateOffSet);
  }

  clearFilter() {
    this.vinError = '';
    this.vin = '';
    this.keywordVin.nativeElement.focus();
  }

  clearLicenseFilter() {
    this.licensePlate = '';
    this.licensePlateError = '';
    this.vinError = '';
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  goBack() {
    this.router.navigate(['/dashboard']).then();
  }

  orderDateChanged() {
    this.getAvailableContractTypes();
    this.selectedContractType = null;
    this.warranty.contract.contractType = null;
    this.warranty.contract.contractCode = null;
  }

  canAbort() {
    return this.authService.isAdmin() ||
      this.warranty.warrantyStatus.toLowerCase() === 'in progress' ||
      this.warranty.warrantyStatus.toLowerCase() === 'accepted';
  }

  deliveryLocationChanged() {
    if (this.warranty.contract.contractType === 'MINI NEXT YUC'){
      this.warranty.contract.deliveryLocation = this.sellingDealer.deliveringAgent;
      this.warranty.dealerNumber = this.sellingDealer.buno;
      this.warranty.contract.deliveryLocation = this.sellingDealer.dealerName;
    }else {
      this.warranty.dealerNumber = this.sellingDealer.buno;
      this.warranty.contract.deliveryLocation = this.sellingDealer.dealerName;
    }
  }

  searchLicensePlate() {
    this.vinError = '';
    this.licenceError = '';
    this.licensePlateError = '';
    this.licensePlate = this.licensePlate.trim();
    this.licensePlateService.getLicensePlate(this.licensePlate).subscribe((res: any) => {
      this.licensePlateError = '';
      this.vin = res.vin;
      if (res.firstRegistrationDate === undefined || res.firstRegistrationDate === null) {
        this.licensePlateError = 'No First Registration Found for License Plate.';
      } else {
        this.licensePlateSearchResults = res;
        this.searchVin();
      }
    }, error => {
      this.licensePlateError = 'license-plate-error';
    });
  }

  isNL() {
    return this.authService.market() === Market.NL;
  }

  downloadPdf(booklet: string) {
    this.http.downloadBooklet(booklet, 'Toelatingseisen BMW Premium Selection MINI Occasions NEXT.pdf');
  }

  showDealerCorrectionReviews(): boolean {
    return (((this.warranty?.warrantyStatus === 'In Review' || this.warranty?.warrantyStatus === 'In Dealer Correction') &&
      (this.isAdmin || this.messages?.length > 0)) || ((this.warranty?.warrantyStatus === 'Active' || this.warranty?.warrantyStatus === 'Accepted') && this.messages?.length > 0));
  }
}
